import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { TasksQueueState } from '../types'
import featureStateSelector from './featureStateSelector'

export const currentPageSelector = createSelector<ReduxState, TasksQueueState, number>(
  featureStateSelector,
  state => state.pagination.currentPage
)
